import useComputed from '@/hooks/use-computed'
import api from '@/services/api/publickey.js'
import { useState } from 'react'

const usePublicKey = () => {

	const [items, setItems] = useComputed([])

	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(params) {
		setLoading(true);
		const [error, data] = await api.index({
			params,
		});
		setLoading(false);
		if (error || !data?.encPublicKey || !data?.signPublicKey) {
			return setError("Failed to fetch PublicKey");
		}
		return data;
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
	}

}

export default usePublicKey;
